/*
 * Module for an API config item
 */
define(["marionette", "jquery", "messaging/messenger", "./apiConfigModalView"], function (
  Marionette,
  $,
  Messenger,
  ApiConfigModalView,
) {
  var ApiConfigModalController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "apiConfigItem";
      this.region = options.region;
      this.editMode = options.editMode;
    },
    show: function (apiConfig) {
      var _this = this;
      this.apiConfig = apiConfig;
      this.apiConfig.editMode = this.editMode;
      this.view = new ApiConfigModalView.apiConfigModalView({
        model: this.apiConfig,
      });

      //load the auth object for the api
      var authentication = apiConfig.getAuthentication();

      //handle bad save
      apiConfig.on(
        "invalid",
        function (model, error) {
          //Clear errors first
          this.view.clearErrors();
          if ("name" in error) {
            this.view.nameError(error["name"]);
          }
          if ("endpointUrl" in error) {
            this.view.urlError(error["endpointUrl"]);
          }
          if ("rateLimit" in error) {
            this.view.rateLimitError(error["rateLimit"]);
          }
          if ("user" in error) {
            this.view.userError(error["user"]);
          }
          if ("password" in error) {
            this.view.passwordError(error["password"]);
          }
          if ("key" in error) {
            this.view.keyError(error["key"]);
          }
          if ("keyName" in error) {
            this.view.keyNameError(error["keyName"]);
          }
        },
        this,
      );

      this.view.on(
        "done",
        function () {
          //save model
          apiConfig.set("endpointUrl", this.view.getUrlValue());
          apiConfig.set("name", this.view.getNameValue());
          apiConfig.set("rateLimit", this.view.getRateLimit());
          var authType = this.view.getAuthenticationType();
          apiConfig.setAuthentication(authType);
          if (authType === 1) {
            apiConfig.getAuthentication().set("user", this.view.getUsername());
            var password = this.view.getPassword();
            //set the password if it has been updated (which would be when getPassword returns a value)
            if (password !== null) {
              apiConfig.getAuthentication().set("password", password);
            }
          } else if (authType === 2) {
            apiConfig.getAuthentication().set("keyLocation", this.view.getKeyLocation());
            apiConfig.getAuthentication().set("keyName", this.view.getKeyName());
            apiConfig.getAuthentication().set("key", this.view.getApiKey());
          }
          if (Messenger.reqres.request("save:textbox")) {
            apiConfig.saveModel({
              success: function () {
                Messenger.vent.trigger("close:modal");
              },
              error: function (model, response) {
                // Error message will be displayed in an invalid or duplicate URL is entered
                if (response.status === 400) {
                  const errorMessage = Messenger.getErrorFromResponse(response);
                  if (_this.editMode) {
                    Messenger.okDialog(
                      $.t("admin.apiAdmin.updateError", { message: errorMessage }),
                    );
                  } else {
                    Messenger.okDialog($.t("admin.apiAdmin.addError", { message: errorMessage }));
                  }
                } else {
                  Messenger.showErrorFromResponse(response);
                }
              },
            });
          }
        },
        this,
      );

      this.view.on(
        "cancel",
        function () {
          //if item is new, delete it
          if (apiConfig.isNew()) {
            apiConfig.deleteModel();
          }
          Messenger.vent.trigger("close:modal");
        },
        this,
      );

      authentication.onSynced(function () {
        this.showRegion(this.view);
      }, this);
    },
  });

  return ApiConfigModalController;
});
